import {createReducer, getType} from "typesafe-actions"

// Models
import {DoctorStatsStateType} from "../../models"

// Actions
import * as a from "../actions"
import {signOutAsync} from "../../../auth/store/actions"

const InitialDoctorStatsState: DoctorStatsStateType = {
    fetching: false,
    stats: null,
    availableRecords: [],
    availableRecordsFetching: false,
    availableRecordsError: false,
    availableRecordsCurrentPage: 0,
    availableRecordsTotal: 0,
    availableRecordsSize: 5,
    availableRecordsPeriod: "all",
    inProgressRecord: null,
    inProgressRecordFetching: false,
};

const doctorStatsReducer = createReducer<DoctorStatsStateType>(InitialDoctorStatsState, {
    [getType(a.fetchStatsAsync.request)]: state => ({
        ...state,
        fetching: true,
    }),
    [getType(a.fetchStatsAsync.success)]: (state, {payload: stats}) => ({
        ...state,
        stats,
        fetching: false,
    }),
    [getType(a.fetchStatsAsync.failure)]: state => ({
        ...state,
        fetching: false,
    }),
    [getType(a.fetchAvailableRecordsAsync.request)]: state => ({
        ...state,
        availableRecordsFetching: true,
        availableRecordsError: false,
    }),
    [getType(a.fetchAvailableRecordsAsync.success)]: (state, {payload: {records, total}}) => ({
        ...state,
        availableRecordsTotal: total,
        availableRecords: records,
        availableRecordsFetching: false,
        availableRecordsError: false,
    }),
    [getType(a.fetchAvailableRecordsAsync.failure)]: state => ({
        ...state,
        availableRecordsFetching: false,
        availableRecordsError: true,
    }),
    // Also the action the epic listens to for a page change, so it doubles as
    // "a new request is starting" — clearing the flag here is what makes retry
    // work.
    [getType(a.setAvailableRecordsPage)]: (stage, {payload}) => ({
        ...stage,
        availableRecordsCurrentPage: payload,
        availableRecordsError: false,
    }),
    [getType(a.setAvailableRecordSize)]: (stage, {payload}) => ({
        ...stage,
        availableRecordsSize: payload,
    }),
    [getType(a.setAvailableRecordsPeriod)]: (stage, {payload}) => ({
        ...stage,
        availableRecordsPeriod: payload,
    }),
    [getType(a.fetchInProgressRecordAsync.request)]: state => ({
        ...state,
        inProgressRecordFetching: true,
    }),
    [getType(a.fetchInProgressRecordAsync.success)]: (state, {payload}) => ({
        ...state,
        inProgressRecord: payload,
        inProgressRecordFetching: false,
    }),
    [getType(a.fetchInProgressRecordAsync.failure)]: state => ({
        ...state,
        inProgressRecordFetching: false,
    }),
    [getType(signOutAsync.success)]: () => InitialDoctorStatsState,
});

export default doctorStatsReducer